'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _inputNumber = require('antd/lib/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _timePicker = require('antd/lib/time-picker');

var _timePicker2 = _interopRequireDefault(_timePicker);

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _checkbox = require('antd/lib/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _switch = require('antd/lib/switch');

var _switch2 = _interopRequireDefault(_switch);

var _card = require('antd/lib/card');

var _card2 = _interopRequireDefault(_card);

var _upload = require('antd/lib/upload');

var _upload2 = _interopRequireDefault(_upload);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _tabs = require('antd/lib/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _localeContext = require('../../core/localeContext');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomFormBase = (_dec = (0, _localeContext.localeContext)('CustomForm', {
  illegal: '表单校验失败',
  dataIndex: '数据项',
  legend: '数据结构',
  upload: '上传文件',
  save: '保存',
  cancel: '取消'
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(CustomFormBase, _React$PureComponent);

  function CustomFormBase(props) {
    _classCallCheck(this, CustomFormBase);

    var _this = _possibleConstructorReturn(this, (CustomFormBase.__proto__ || Object.getPrototypeOf(CustomFormBase)).call(this, props));

    _this._dataSource = _this._asMutable(props.dataSource);
    _this.optionsMap = {};
    _this.refsMap = {};

    _this._submitting = false;
    _this._validating = false;
    return _this;
  }

  _createClass(CustomFormBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataSource !== this.props.dataSource) {
        this._dataSource = this._asMutable(nextProps.dataSource);
      }
    }
  }, {
    key: '_asMutable',
    value: function _asMutable(obj) {
      var _this2 = this;

      if (Array.isArray(obj)) {
        var arr = [];
        obj.forEach(function (d) {
          arr.push(_this2._asMutable(d));
        });
        return arr;
      } else if (Object(obj) === obj) {
        var newObj = {};
        for (var key in obj) {
          if (Object(obj[key]) === obj[key]) {
            newObj[key] = this._asMutable(obj[key]);
          } else {
            if (obj.hasOwnProperty(key)) {
              newObj[key] = obj[key];
            }
          }
        }
        return newObj;
      } else {
        return obj;
      }
    }
  }, {
    key: 'validate',
    value: function validate(keep, attrName) {
      var _this3 = this;

      this._validating = true;
      return new Promise(function (resolve, reject) {
        _this3.props.form.validateFields(function (err, body) {
          if (err) {
            _this3._validating = false;
            reject(err);
            _message2.default.error(_this3.getLocale('illegal'));
          } else {
            body = _this3.parseBody(body);

            var promises = [];
            /* eslint-disable react/no-string-refs */
            for (var name in _this3.refs) {
              promises.push(_this3.refs[name].validate(keep, name));
            }
            Promise.all(promises).then(function (bodys) {
              _this3._validating = false;
              if (bodys.length) {
                body = bodys.reduce(function (p, c) {
                  if (Array.isArray(c)) {
                    if (p[c[0]]) {
                      p[c[0]].push(c[1]);
                    } else {
                      p[c[0]] = [c[1]];
                    }
                    return p;
                  } else {
                    return Object.assign(p, c);
                  }
                }, body);
              }
              if (keep && attrName) {
                var arr = attrName.split('@');
                // 数组形式
                if (arr.length === 2) {
                  resolve([arr[0], body]);
                } else {
                  resolve(_defineProperty({}, attrName, body));
                }
              } else {
                resolve(body);
              }
            }, function (errs) {
              _this3._validating = false;
              _message2.default.error(_this3.getLocale('illegal'));
              reject(errs);
            });
          }
        });
      });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(onSubmit, keep) {
      var _this4 = this;

      if (this.props.disabled) {
        return Promise.resolve(true);
      }
      this._submitting = true;
      return this.validate(keep).then(function (body) {
        var result = void 0;
        try {
          if (onSubmit) {
            result = onSubmit(body, _this4.props.dataSource);
          } else if (_this4.props.onSubmit) {
            result = _this4.props.onSubmit(body, _this4.props.dataSource);
          }
        } catch (e) {
          window.console.error(e);
        }
        if (result && result.then) {
          result.then(function () {
            _this4._submitting = false;
          }, function () {
            _this4._submitting = false;
          });
        } else {
          _this4._submitting = false;
        }
        return result;
      });
    }
  }, {
    key: 'parseBody',
    value: function parseBody(body) {
      if (this.props.normalize) {
        for (var name in body) {
          if (body[name] !== undefined) {
            // 组合成数组
            if (this.optionsMap[name].getValue) {
              body[name] = this.optionsMap[name].getValue(body[name]);
            }
            if (this.optionsMap[name].originName) {
              var v = body[name];
              delete body[name];
              name = this.optionsMap[name].originName;
              body[name] = body[name] || [];
              body[name].push(v);
            }
          }
        }
      }
      if (this.props.name) {
        return _defineProperty({}, this.props.name, body);
      } else {
        return body;
      }
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.context.router.goBack();
    }
  }, {
    key: 'getFormLayout',
    value: function getFormLayout(option, extra) {
      return Object.assign({}, this.props.formLayout, {
        label: option.title || option.name || extra.title,
        required: option.required || extra.required,
        hasFeedback: option.hasFeedback || extra.hasFeedback,
        help: option.help || extra.help,
        className: option.className || extra.className,
        extra: option.extra ? option.extra : option.icon || null
      });
    }
  }, {
    key: 'getInitialValue',
    value: function getInitialValue(option, defaultValue) {
      var dataIndex = option.name || option.dataIndex;
      var initialValue = this._dataSource[dataIndex];
      if (this.props.normalize && initialValue !== undefined) {
        switch (option.type) {
          case 'boolean':
            if (typeof initialValue !== 'boolean') {
              initialValue = [false, true][parseInt(initialValue, 10)];
              option.getValue = function (value) {
                return value + 0;
              };
              option.builtIn = true;
            }
            break;
          case 'array':
            if (!Array.isArray(initialValue)) {
              initialValue = initialValue.split(',');
              option.getValue = function (value) {
                return Array.isArray(value) ? value.join(',') : String(value);
              };
              option.builtIn = true;
            }
            break;
        }
      }
      if (initialValue === undefined && !this.props.loading) {
        initialValue = defaultValue;
      }
      if (!this.optionsMap[dataIndex]) {
        this._dataSource[dataIndex] = initialValue;
        this.optionsMap[dataIndex] = option;
      }
      return initialValue;
    }
  }, {
    key: 'renderInput',
    value: function renderInput(option, key, _onChange) {
      var _this5 = this;

      var dataIndex = option.name || option.dataIndex;
      if (!dataIndex) {
        return null;
      }

      var noFlattern = option.noFlattern === undefined ? this.props.noFlattern : option.noFlattern;
      var dataSource = noFlattern ? option.dataSource || this._dataSource : this._dataSource;
      if (option.children) {
        if (option.type === 'array') {
          var isArr = option.children[0].children;
          var dataSources = dataSource[dataIndex] || [];
          var tabs = [];
          var indexes = [];
          dataSources.forEach(function (d, index) {
            indexes.push(index + '');
            tabs.push({
              index: index + '',
              data: d
            });
          });
          // 已经赋值过了
          if (this.refsMap[dataIndex]) {
            // 发现传入的dataSources有值，说明外部dataSource有变化，需要重新赋值，提取是之前的值不一样
            if (dataSources.length && dataSources !== this.refsMap[dataIndex].dataSources) {
              this.refsMap[dataIndex] = {
                indexes: indexes,
                activeKey: indexes[0],
                tabs: tabs,
                dataSources: dataSources
              };
            }
          } else {
            // 赋值
            this.refsMap[dataIndex] = {
              indexes: indexes,
              activeKey: indexes[0],
              tabs: tabs,
              dataSources: dataSources
            };
          }
          var obj = this.refsMap[dataIndex];
          return _react2.default.createElement(
            _card2.default,
            {
              className: 'j-com-customForm-card',
              key: key,
              title: option.title || dataIndex },
            _react2.default.createElement(
              _tabs2.default,
              {
                onChange: function onChange(activeKey) {
                  obj.activeKey = activeKey;
                  if (_this5.mounted) {
                    _this5.forceUpdate();
                  }
                },
                onEdit: function onEdit(targetKey, action) {
                  var idx = void 0;
                  if (action === 'add') {
                    idx = obj.indexes.length ? 1 + parseInt(obj.indexes[obj.indexes.length - 1], 10) + '' : '0';
                    obj.indexes.push(idx);
                    obj.tabs.push({
                      index: idx,
                      data: {}
                    });
                    obj.activeKey = idx + '';
                  } else {
                    idx = obj.indexes.indexOf(targetKey);
                    obj.indexes.splice(idx, 1);
                    obj.tabs.splice(idx, 1);
                    // 选中项小于触发项
                    if (obj.activeKey >= targetKey) {
                      if (idx > 0) {
                        obj.activeKey = idx - 1;
                      } else if (obj.indexes.length) {
                        obj.activeKey = idx + 1;
                      } else {
                        obj.activeKey = '';
                      }
                      obj.activeKey = obj.activeKey + '';
                    }
                  }
                  if (_this5.mounted) {
                    _this5.forceUpdate();
                  }
                },
                activeKey: obj.activeKey,
                type: 'editable-card' },
              obj.tabs.map(function (item) {
                var key = dataIndex + '@' + obj.indexes[item.index];
                return _react2.default.createElement(
                  _tabs2.default.TabPane,
                  {
                    tab: _this5.getLocale('dataIndex') + item.index,
                    key: item.index,
                    closable: true,
                    forceRender: true },
                  isArr ? (_this5.optionsMap[key] = Object.assign({
                    name: key,
                    dataSource: dataSources[item.index],
                    originName: dataIndex,
                    title: _this5.getLocale('legend')
                  }, option.children[item.index])) && _this5.renderInput(_this5.optionsMap[key], key, function (e) {
                    if (_onChange) {
                      var arr = obj.tabs.map(function (d) {
                        return d.data;
                      });
                      var o = Object.assign({}, _this5.optionsMap[key]);
                      obj.tabs[item.index].data = arr[item.index] = CustomForm.getValueFromEvent(e, o);
                      o.name = o.originName;
                      _onChange(arr, o);
                    }
                  }) : _react2.default.createElement(CustomForm, {
                    formLayout: _this5.props.formLayout,
                    disabled: _this5.props.disabled,
                    ref: key,
                    onChange: function onChange(e, o) {
                      if (_onChange) {
                        var arr = obj.tabs.map(function (d) {
                          return d.data;
                        });
                        arr[item.index][o.name] = CustomForm.getValueFromEvent(e, o);
                        _onChange(arr, option);
                      }
                    },
                    options: option.children,
                    noLabel: _this5.props.noLabel,
                    parentDataSource: _this5._dataSource,
                    dataSource: dataSources[item.index],
                    noButton: true,
                    noFlattern: noFlattern })
                );
              })
            )
          );
        } else if (noFlattern) {
          var formElm = _react2.default.createElement(CustomForm, {
            formLayout: this.props.formLayout,
            disabled: this.props.disabled,
            key: key,
            ref: dataIndex,
            title: option.title,
            name: option.embed ? '' : dataIndex,
            onChange: function onChange(e, o) {
              if (_onChange) {
                var _obj = _this5.refsMap[dataIndex] ? _this5.refsMap[dataIndex] : _this5.refsMap[dataIndex] = {};
                _obj[o.name] = CustomForm.getValueFromEvent(e, o);
                _onChange(_obj, option);
              }
            },
            options: option.children,
            noLabel: this.props.noLabel,
            parentDataSource: this._dataSource,
            dataSource: dataSource[dataIndex],
            noButton: true,
            noFlattern: noFlattern });

          return option.embed ? _react2.default.createElement(
            _form2.default.Item,
            _extends({ key: key }, this.props.formLayout, { label: option.title || dataIndex }),
            _react2.default.createElement(
              'div',
              { style: {
                  border: '1px solid #ddd',
                  padding: 10
                } },
              formElm
            )
          ) : formElm;
        } else {
          var renderInput = this.renderInput.bind(this);
          return _react2.default.createElement(
            _card2.default,
            {
              className: 'j-com-customForm-card',
              key: key,
              title: option.title || dataIndex },
            option.children.map(renderInput)
          );
        }
      }

      var propsByState = option.getProps ? option.getProps.call(this, this._dataSource, function (nextState) {
        Object.assign(_this5._dataSource, nextState);
        _this5.forceUpdate();
      }, this.props.form) : {};
      if (propsByState.name === false) {
        return null;
      }
      var initialValue = this.getInitialValue(option, propsByState.default || option.default);

      var formItemProps = this.getFormLayout(option, propsByState);
      if (this.props.noLabel) {
        formItemProps.label = null;
      }
      var rules = [].concat(this.props.rules[dataIndex] || []);
      var defaultProps = {
        disabled: option.disabled || this.props.disabled,
        placeholder: option.placeholder
      };
      var decoratorProps = {
        defaultValue: initialValue,
        rules: rules.concat(option.rules || propsByState.rules || []),
        getValueFromEvent: function getValueFromEvent(e) {
          var v = CustomForm.getValueFromEvent(e, option);
          _this5._dataSource[dataIndex] = v;
          if (_onChange) {
            _onChange(v, option);
          }
          if (option.onChange) {
            option.onChange(_this5._dataSource, function (nextState) {
              _this5.props.form.setFieldsValue(nextState);
            });
          }
          return v;
        }
      };
      if (option.renderInput) {
        return option.renderInput(option, function (node, dpros) {
          return _react2.default.createElement(
            _form2.default.Item,
            _extends({ key: key }, formItemProps),
            _this5.props.form.getFieldDecorator(dataIndex, Object.assign(decoratorProps, dpros))(node)
          );
        }, Object.assign(defaultProps, propsByState), this.props.form);
      } else {
        var input = CustomForm.getFieldInput(option, defaultProps, propsByState, decoratorProps);
        return _react2.default.createElement(
          _form2.default.Item,
          _extends({ key: key }, formItemProps),
          this.props.form.getFieldDecorator(dataIndex, decoratorProps)(input)
        );
      }
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.props.form.resetFields();
      this.refsMap = {};
      /* eslint-disable react/no-string-refs */
      for (var name in this.refs) {
        this.refs[name].clear();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _buttons = CustomForm.getButtons(this.props.buttons, {
        noButton: this.props.noButton,
        save: this.getLocale('save'),
        cancel: this.getLocale('cancel'),
        onSubmit: function onSubmit() {
          return _this6.handleSubmit(null, _this6.props.keep);
        },
        onCancel: function onCancel() {
          return _this6.handleCancel();
        }
      });
      var buttons = _buttons ? _react2.default.createElement(
        _form2.default.Item,
        {
          wrapperCol: {
            offset: this.props.formLayout.labelCol.span,
            span: this.props.formLayout.wrapperCol.span
          } },
        _buttons
      ) : null;

      var compact = this.props.compact ? 'j-com-customForm-compact ' : '';
      var className = compact + this.props.className;
      var formElm = _react2.default.createElement(
        _form2.default,
        {
          className: 'j-com-customForm ' + className,
          style: this.props.style,
          onSubmit: function onSubmit(e) {
            e.preventDefault();
            _this6.handleSubmit(null, _this6.props.keep);
          },
          layout: this.props.layout },
        this.props.options.map(function (option, key) {
          return _this6.renderInput(option, key, _this6.props.onChange);
        }),
        ' ',
        buttons
      );
      if (this.props.name) {
        return _react2.default.createElement(
          _card2.default,
          {
            className: 'j-com-customForm-card ' + className,
            title: this.props.title || this.props.name },
          formElm
        );
      } else {
        return formElm;
      }
    }
  }, {
    key: 'submitting',
    get: function get() {
      return this._submitting;
    }
  }, {
    key: 'validating',
    get: function get() {
      return this._validating;
    }
  }]);

  return CustomFormBase;
}(_react2.default.PureComponent), _class2.contextTypes = {
  router: _propTypes2.default.object
}, _class2.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,

  dataSource: _propTypes2.default.object,
  parentDataSource: _propTypes2.default.object,
  options: _propTypes2.default.array.isRequired,
  formLayout: _propTypes2.default.object,
  rules: _propTypes2.default.object,
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  layout: _propTypes2.default.string,
  buttons: _propTypes2.default.object,
  name: _propTypes2.default.string,
  title: _propTypes2.default.string,
  noLabel: _propTypes2.default.bool,
  noButton: _propTypes2.default.bool,
  noFlattern: _propTypes2.default.bool,
  normalize: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  keep: _propTypes2.default.bool,
  form: _propTypes2.default.object,
  compact: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
}, _class2.defaultProps = {
  className: '',

  layout: 'horizontal',
  dataSource: {},
  compact: true,
  rules: {},
  normalize: true,
  options: [],
  formLayout: {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 19
    },
    hasFeedback: true,
    required: true
  }
}, _temp)) || _class);


var CustomForm = _form2.default.create({ withRef: true })(CustomFormBase);

CustomForm.getLabel = function getLabel(item, option) {
  if (option.getLabel) {
    return option.getLabel(item);
  } else {
    return option.lableKey ? item[option.lableKey] : item.label || item.name;
  }
};
CustomForm.getValueFromEvent = function getValueFromEvent(e, option) {
  var v = void 0;
  if (Object(e) === e) {
    if ((0, _isPlainObject2.default)(e) || (0, _isPlainObject2.default)(e.__proto__)) {
      if (option.valuePropName) {
        v = e[option.valuePropName];
      } else {
        v = e.target ? e.target.value : e;
      }
    } else {
      v = e.target && e.target.nodeName ? e.target.value : e;
    }
  } else {
    v = e;
  }
  return option.builtIn && option.getValue ? option.getValue(v) : v;
};

CustomForm.getButtons = function getButtons(buttons, props) {
  if (!buttons && !props.noButton) {
    buttons = [];
    if (props.save) {
      buttons.push(_react2.default.createElement(
        _button2.default,
        {
          key: 0,
          onClick: props.onSubmit,
          style: {
            marginRight: 10
          },
          type: 'primary' },
        props.save || 'save'
      ));
    }
    if (props.cancel) {
      buttons.push(_react2.default.createElement(
        _button2.default,
        { key: 1,
          onClick: props.onCancel,
          style: {
            marginRight: 10
          },
          type: 'default' },
        props.cancel || 'cancel'
      ));
    }
  }
  return buttons;
};
/**
 * option = {
 *  dataType | type,
 *  // 枚举值
 *  enum,
 *  options,
 *
 *  // 特殊组件
 *  format,
 *  mode,
 *  // 上传
 *  dragger,
 *  action,
 *  valuePropName,
 *
 *  // 指定组件
 *  Component,
 *
 *  // 数字
 *  max,
 *  maxLength,
 *  maximum,
 *  // 置灰
 *  disabled,
 *  // 提示
 *  placeholder
 * }
 */
CustomForm.getFieldInput = function getFieldInput(option, props, stateProps, decorator) {
  var input = void 0;
  var dataFormat = void 0;
  if (option.enum) {
    input = _react2.default.createElement(
      _radio2.default.Group,
      _extends({}, props, stateProps),
      option.enum.map(function (item) {
        return _react2.default.createElement(
          _radio2.default,
          { key: item, value: item },
          item
        );
      })
    );
  } else {
    if (option.format) {
      switch (option.format) {
        case 'DATE_TIME':
          dataFormat = option.dataFormat || 'YYYY-MM-DD HH:mm:ss';
          decorator.initialValue = (0, _moment2.default)(decorator.defaultValue);
          input = _react2.default.createElement(_datePicker2.default, _extends({
            style: {
              maxWidth: 250
            },
            showTime: true,
            format: dataFormat
          }, props, stateProps));
          break;
        case 'DATE':
          dataFormat = option.dataFormat || 'YYYY-MM-DD';
          decorator.initialValue = (0, _moment2.default)(decorator.defaultValue);
          input = _react2.default.createElement(_datePicker2.default, _extends({
            style: {
              maxWidth: 250
            },
            format: dataFormat
          }, props, stateProps));
          break;
        case 'TIME':
          dataFormat = option.dataFormat || 'HH:mm:ss';
          decorator.initialValue = (0, _moment2.default)(decorator.defaultValue);
          input = _react2.default.createElement(_timePicker2.default, _extends({
            style: {
              maxWidth: 250
            },
            format: dataFormat
          }, props, stateProps));
          break;
        case 'DATE_RANGE':
          input = _react2.default.createElement(_datePicker2.default.RangePicker, _extends({}, props, stateProps));
          break;
        case 'CDN_PIC':
        case 'FILE':
          dataFormat = option.description || 'Click or drag files to the upload area';
          decorator.valuePropName = option.valuePropName = 'fileList';
          if (option.dragger) {
            input = _react2.default.createElement(
              _upload2.default.Dragger,
              _extends({}, props, stateProps, {
                listType: option.format === 'FILE' ? 'text' : 'picture',
                action: option.action }),
              _react2.default.createElement(
                'p',
                { className: 'ant-upload-drag-icon' },
                _react2.default.createElement(_icon2.default, { type: 'inbox' })
              ),
              _react2.default.createElement(
                'p',
                { className: 'ant-upload-text' },
                dataFormat
              )
            );
          } else {
            input = _react2.default.createElement(
              _upload2.default,
              _extends({}, props, stateProps, {
                action: option.action,
                listType: option.format === 'FILE' ? 'text' : 'picture' }),
              _react2.default.createElement(
                _button2.default,
                null,
                _react2.default.createElement(_icon2.default, { type: 'upload' }),
                ' ',
                option.description || 'Upload'
              )
            );
          }
          break;
        case 'SELECT':
          var options = stateProps.options || option.options;
          if (option.mode === 'radio') {
            input = _react2.default.createElement(
              _radio2.default.Group,
              _extends({}, props, stateProps),
              options.map(function (item) {
                return _react2.default.createElement(
                  _radio2.default,
                  {
                    key: item.value,
                    value: item.value,
                    disabled: item.disabled },
                  CustomForm.getLabel(item, option)
                );
              })
            );
          } else if (option.mode === 'checkbox') {
            input = _react2.default.createElement(_checkbox2.default.Group, _extends({}, props, stateProps, { options: options }));
          } else {
            input = _react2.default.createElement(
              _select2.default,
              _extends({ mode: option.mode }, props, stateProps),
              options.map(function (item) {
                return _react2.default.createElement(
                  _select2.default.Option,
                  {
                    key: item.value || item.id,
                    value: item.value || item.id,
                    disabled: item.disabled },
                  CustomForm.getLabel(item, option)
                );
              })
            );
          }
          break;
        case 'Component':
          input = _react2.default.createElement(option.Component, _extends({}, props, stateProps));
          break;
        case 'Element':
        case 'TEXT':
        case 'Function':
        case 'JSON':
          input = _react2.default.createElement(_input2.default.TextArea, _extends({
            autosize: {
              minRows: 4,
              maxRows: 10
            }
          }, props, {
            onPressEnter: decorator.getValueFromEvent,
            onBlur: decorator.getValueFromEvent
          }, stateProps));
          break;
        default:
          input = _react2.default.createElement(_input2.default, _extends({}, props, stateProps));
      }
    } else {
      var type = option.dataType || option.type;
      switch (type) {
        case 'number':
        case 'integer':
          var max = option.max;
          if (!max) {
            var maxLength = maxLength = option.maxLength ? option.maxLength : 10;
            max = +new Array(maxLength).join(9);
            if (option.maximum) {
              max = Number(maxLength + '0.' + option.maximum);
            }
          }
          input = _react2.default.createElement(_inputNumber2.default, _extends({
            style: {
              maxWidth: 250
            },
            min: option.min ? option.min : 0,
            max: max
          }, props, stateProps));
          break;
        case 'boolean':
          decorator.valuePropName = option.valuePropName || 'checked';
          var placeholder = [].concat(option.placeholder);
          input = _react2.default.createElement(_switch2.default, _extends({
            unCheckedChildren: placeholder[0],
            checkedChildren: placeholder[1]
          }, props, stateProps));
          break;
        case 'string':
        default:
          input = _react2.default.createElement(_input2.default, _extends({}, props, stateProps));
          break;
      }
    }
  }
  decorator.initialValue = decorator.initialValue || decorator.defaultValue;
  return input;
};

CustomForm.prototype.getRealInstance = function () {
  return this.refs.wrappedComponent;
};
['handleSubmit', 'clear', 'validate'].forEach(function (method) {
  CustomForm.prototype[method] = function () {
    var _refs$wrappedComponen;

    return (_refs$wrappedComponen = this.refs.wrappedComponent)[method].apply(_refs$wrappedComponen, arguments);
  };
});
Object.defineProperties(CustomForm.prototype, {
  submitting: {
    get: function get() {
      return this.refs.wrappedComponent.submitting;
    }
  },
  validating: {
    get: function get() {
      return this.refs.wrappedComponent.validating;
    }
  }
});

exports.CustomForm = CustomForm;


//////////////////
// WEBPACK FOOTER
// ./src/components/customForm/index.jsx
// module id = 28
// module chunks = 0